import { FINDER_FILTER_MENU_ICON } from "./components/constants";
import { booleanAttribute } from "#ce/utils/props";
import { FINDER_FILTER_ORDER_ACTIVATION, FINDER_FILTER_ORDER_DOCUMENT } from "./composables/constants";

export const props = Object.freeze({
  /** Icon name for the Filters menu trigger. @type {String} */
  menuIcon: {
    type: String,
    default: FINDER_FILTER_MENU_ICON,
  },
  /** Unique reference for external contributors in this DOM tree. @type {String} */
  contributionRef: {
    type: String,
    default: undefined,
  },
  /**
   * Order active chips by activation time or by their configured document position.
   * Inactive chips follow in document order in either mode.
   * @type {String}
   * @values activation, document
   */
  activeOrder: {
    type: String,
    default: FINDER_FILTER_ORDER_ACTIVATION,
    validator: function isActiveOrder(value) {
      return [FINDER_FILTER_ORDER_ACTIVATION, FINDER_FILTER_ORDER_DOCUMENT].includes(value);
    },
  },
  /**
   * Include dependent filters in the menu while their chips are withheld.
   * Opening a row reveals its filter without applying a value.
   * @type {Boolean|String}
   */
  includeWithheld: booleanAttribute(),
});
